// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2oQVe","title":"Images45_title__2Y95G","images":"Images45_images__Jb1Uu"};